











































import { store } from "@/store/store";
import { DeviceDataTable, StateEnum } from "@/types/types";
import DeviceTable from "@/components/Table/Device/DeviceTable.vue";
import DeviceCards from "@/components/Table/Device/DeviceCards.vue";
import Utils from "@/utils/utils";
import Vue from "vue";

interface DeviceDataData {
  items_displayed: any;
  defaultItemPerPage: number;
}

export default Vue.extend({
  name: "DeviceData",
  components: { DeviceTable, DeviceCards },
  props: {
    selected: {
      type: Array as () => Array<string>
    },
    shouldDisplayDescriptionPanel: {
      type: Function
    },
    onSelectChange: {
      type: Function
    },
    searchFilter: {
      type: Object
    },
    display: {
      type: String
    },
    sortBy: {
      type: String,
      default: undefined
    },
    sortDesc: {
      type: Boolean,
      default: undefined
    }
  },
  created() {
    const params = Utils.getUrlParameters();
    if (params.get("perPage") && params.get("perPage") !== null) {
      this.defaultItemPerPage = parseInt(params.get("perPage") as string);
    }
  },
  data(): DeviceDataData {
    return {
      items_displayed: [],
      defaultItemPerPage: 50
    };
  },
  methods: {
    format_data(): Array<DeviceDataTable> {
      const devices_by_id = store.getters.DEVICE_ALL_ID;
      let devices: Array<DeviceDataTable> = [];
      devices_by_id.forEach((device_id: string) => {
        let device: any = { ...store.getters.DEVICE_BY_ID[device_id] };
        device.disponibility = store.getters.STATE_BY_ID[device.state].name === StateEnum.RESERVE_DISP;
        device.state = store.getters.STATE_BY_ID[device.state].name;
        device.category = store.getters.CATEGORY_BY_ID[device.category].name;
        device.agence = store.getters.AGENCE_BY_ID[device.agence].name;
        device.updated = Utils.transformDateToYMD(device.updated);
        if (device.poste) {
          const poste = store.getters.POSTE_BY_ID[device.poste];
          if (poste !== undefined && poste !== null) {
            device.poste = poste.name_poste;
            if (poste.survey !== undefined) {
              const survey = store.getters.SURVEY_BY_ID[poste.survey];
              if (survey !== undefined) {
                device.campaign = survey.name_survey;
              } else {
                device.campaign = "Pas de campagne liée";
              }
            }
          } else {
            device.poste = "Pas de poste lié";
            device.campaign = "Pas de campagne liée";
          }
        } else {
          device.poste = "Pas de poste lié";
          device.campaign = "Pas de campagne liée";
        }
        /* device.campaign =
          device.poste !== null
            ? store.getters.SURVEY_BY_ID[store.getters.POSTE_BY_ID[device.poste].survey].name_survey
            : "Pas de campagne liée";
        device.poste = device.poste !== null ? store.getters.POSTE_BY_ID[device.poste].name_poste : "Pas de poste lié"; */
        devices.push(device);
      });
      return devices as Array<DeviceDataTable>;
    },
    shouldDisplayCreateModal(device_id: string): void {
      this.$emit("shouldDisplayModifyModal", device_id);
    },
    shouldDisplayDeleteModal(device_id: string): void {
      this.$emit("shouldDisplayDeleteModal", device_id);
    },
    shouldDisplayAssignationModal(device_id: string): void {
      this.$emit("shouldDisplayAssignationModal", device_id);
    },
    currentItems(items: Array<any>) {
      this.items_displayed = items.map((item) => item._id) as Array<string>;
    },
    selectedToggleAll(selected: boolean): void {
      this.onSelectChange(selected ? [...this.items_displayed] : []);
    },
    selectedChange(_id: string): void {
      let selected_copy = [...this.selected];
      const found_id = selected_copy.findIndex((select: string) => select === _id);
      found_id !== -1 ? selected_copy.splice(found_id, 1) : selected_copy.push(_id);
      this.onSelectChange(selected_copy);
    },
    customFilter(value: string | undefined, search: string, item: { [key: string]: string | boolean }) {
      const search_ = JSON.parse(search);
      return ![
        this.categoryFilter(search_.category, item.category as string),
        this.agenceFilter(search_.agence, item.agence as string),
        this.stateFilter(search_.state, item.state as string),
        this.disponibilityFilter(search_.disponibility, item.disponibility as boolean),
        this.material_nameFilter(search_.material_name, item.material_name as string),
        this.campaign_nameFilter(search_.campaign, item.campaign as string),
        this.updated_filter(search_.updated, item.updated as string)
      ].includes(false);
    },
    categoryFilter(category: string | null, item: string): boolean {
      return category === "" || category === null ? true : category === item ? true : false;
    },
    agenceFilter(agence: string | null, item: string): boolean {
      return agence === "" || agence === null ? true : agence === item ? true : false;
    },
    stateFilter(state: string | null, item: string): boolean {
      return state === "" || state === null ? true : state === item ? true : false;
    },
    disponibilityFilter(disponibility: string | null, item: boolean): boolean {
      if (disponibility === "" || disponibility === null) return true;
      const disponibility_ = disponibility === "true" ? true : false;
      return disponibility_ === item ? true : false;
    },
    material_nameFilter(material_name: string | null, item: string): boolean {
      if (material_name === "" || material_name === null) return true;
      return item.toLowerCase().indexOf(material_name.toLowerCase().trim()) !== -1 ? true : false;
    },
    campaign_nameFilter(campaign_name: string | null, item: string): boolean {
      if (campaign_name === "" || campaign_name === null) return true;
      return item.toLowerCase().indexOf(campaign_name.toLowerCase().trim()) !== -1 ? true : false;
    },
    updated_filter(updated_date: string | null, item: string): boolean {
      if (updated_date === "" || updated_date === null) return true;
      return Utils.getDifferenceBetweenDate(new Date(updated_date).getTime(), new Date(item).getTime()) <= 0;
    },
    pagination(pagination: any) {
      const params = Utils.getUrlParameters();
      params.set("perPage", pagination.itemsPerPage.toString());
      history.pushState(null, "", "?" + params.toString());
    }
  },
  watch: {
    display() {
      const params = Utils.getUrlParameters();
      if (params.get("perPage") && params.get("perPage") !== null) {
        this.defaultItemPerPage = parseInt(params.get("perPage") as string);
      }
    }
  }
});
